module.exports = __webpack_public_path__ + "images/help/guide_video_todo-2dd29951ffddde5a7a6eb79c9d7aff5a.png";